import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

@Injectable({ providedIn: 'root' })
export class LocationsService {
  private get url() { return ApiConstants.URL_LOCATIONS; }

  constructor(private http: HttpClient) {}

  async listEmirates(): Promise<any[]> {
    const response = await firstValueFrom(this.http.get<any>(`${this.url}/emirates`));
    return response.data;
  }

  async listAreas(emirate: string): Promise<any[]> {
    const response = await firstValueFrom(
      this.http.get<any>(`${this.url}/areas?emirate=${encodeURIComponent(emirate)}`)
    );
    return response.data;
  }

  async getCenter(emirate?: string, area?: string): Promise<{ lat: number; lng: number; zoom?: number }> {
    const params = new URLSearchParams();
    if (emirate) {
      params.set('emirate', emirate);
    }
    if (area) {
      params.set('area', area);
    }
    const qs = params.toString();
    const response = await firstValueFrom(
      this.http.get<any>(`${this.url}/center${qs ? `?${qs}` : ''}`)
    );
    return response.data;
  }
}
